import {PopUp} from '../../../../Atoms/PopUp';
import {useMutation, useQuery} from '@apollo/client';
import {GetValues4CharacterCreation} from '../../../../GraphQL/CharacterQueries';
import {emptyNPC, NPC} from '../../../../redux/slices/npc/npcType';
import React, {ChangeEvent, useEffect} from 'react';
import Input from '../../../../Atoms/Input';
import {toInteger} from 'lodash';
import {DropDown} from '../../../../Atoms/DropDown';
import Button from '../../../../Atoms/Button';
import {CreateNPC} from '../../../../GraphQL/NPCMutations';
import {toast} from 'react-toastify';
import {GetAllNpcsQuery} from '../../../../GraphQL/NPCQueries';
import {useAppDispatch} from '../../../../redux/hooks';
import {setIsAppLoading} from '../../../../redux/slices/content/contentSlice';

export const AdventureCreateNPCPopUp = (props: {
    close: () => void;
    adventureId: number;
}) => {
    const dispatch = useAppDispatch();

    const { data: creationData } = useQuery(GetValues4CharacterCreation);
    const [ createNewNPCHook, {}] = useMutation(CreateNPC)

    const [ newNPC, setNewNPC ] = React.useState<NPC>(emptyNPC);
    const [ classes, setClasses ] = React.useState<any[]>([]);
    const [ subclasses, setSubclasses ] = React.useState<any[]>([]);
    const [ race, setRaces ] = React.useState<any[]>([]);
    const [ subrace, setSubraces ] = React.useState<any[]>([]);

    useEffect(() => {
        if (creationData) {
            const ddData = [];
            for (const foundClass of creationData.getClasses) {
                ddData.push({
                    itemValue: foundClass.classId,
                    itemText: foundClass.className,
                    otherItems: foundClass.Subclass
                })
            }

            setClasses(ddData);

            const raceData = [];
            for (const foundRace of creationData.getRaces) {
                raceData.push({
                    itemValue: foundRace.raceId,
                    itemText: foundRace.raceName,
                    otherItems: foundRace.Subrace
                })
            }

            setRaces(raceData);
        }
    }, [ creationData ])

    const handleCreateNPC = async () => {
        dispatch(setIsAppLoading({
            isAppLoading: true,
            loadingText: 'NPC wird erstellt'
        }));
        const response = await createNewNPCHook({
            variables: {
                adventureId: toInteger(props.adventureId),
                npcLevel: toInteger(newNPC.npcLevel),
                npcName: newNPC.npcName,
                classId: newNPC.Class.classId > 0 ? toInteger(newNPC.Class.classId) : null,
                subclassId: newNPC.Subclass.subclassId > 0 ? toInteger(newNPC.Subclass.subclassId) : null,
                raceId: newNPC.Race.raceId > 0 ? toInteger(newNPC.Race.raceId) : null,
                subraceId: newNPC.Subrace.subraceId > 0 ? toInteger(newNPC.Subrace.subraceId) : null
            },
            refetchQueries: [{
                query: GetAllNpcsQuery,
                variables: {
                    adventureId: toInteger(props.adventureId)
                }
            }]
        })

        dispatch(setIsAppLoading({
            isAppLoading: false,
            loadingText: ''
        }));

        if (response.errors) {
            toast.error('Es ist ein Fehler beim Erstellen aufgetreten');
        } else {
            toast.success('Neuer NPC erstellt');
            props.close();
        }
    }


    return(
        <PopUp onClose={() => props.close()} title="Neuer NPC">
            <div className='row justify-content-end'>
                <div className='col-2'>
                    <Button onClick={ async () => await handleCreateNPC() }>Speichern</Button>
                </div>
            </div>
            <div className='row'>
                <div className='col-6'>
                    <Input type='text' label="Name" value={newNPC.npcName}
                           onChange={(e: ChangeEvent<HTMLInputElement>) => setNewNPC({
                               ...newNPC,
                               npcName: e.target.value
                           })}/>
                </div>
                <div className='col-2'>
                    <Input type="number" label="Level" minValue={1} maxValue={20} value={newNPC.npcLevel}
                           onChange={(e: ChangeEvent<HTMLInputElement>) => setNewNPC({
                               ...newNPC,
                               npcLevel: toInteger(e.target.value)
                           })}/>
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-6'>
                    <DropDown value={newNPC.Race.raceId} setValue={(event) => {
                        const subraceData = []
                        const foundRace = race.find((oneRace: any) => oneRace.itemValue === event.target.value);
                        for (const foundSubrace of foundRace.otherItems) {
                            subraceData.push({
                                itemValue: foundSubrace.subraceId,
                                itemText: foundSubrace.subraceName
                            })
                        }
                        setSubraces(subraceData)
                        setNewNPC({
                            ...newNPC,
                            Race: {
                                ...newNPC.Race,
                                raceId: toInteger(event.target.value),
                                raceName: event.target.name
                            }
                        })
                    }} items={race} label="Volk"/>
                </div>
                {newNPC.Race.raceId > 0 && subrace.length !== 0 && (
                    <div className='col-6'>
                        <DropDown value={newNPC.Subrace.subraceId} setValue={(event) => setNewNPC({
                            ...newNPC,
                            Subrace: {
                                ...newNPC.Subrace,
                                subraceId: toInteger(event.target.value),
                                subraceName: event.target.name
                            }
                        })} items={subrace} label="Subvolk"/>
                    </div>
                )}
            </div>
            <div className='row mt-2'>
                <div className='col-6'>
                    <DropDown value={newNPC.Class.classId} setValue={(event) => {
                        const subclassArray = []
                        const foundClass = classes.find((oneClass: any) => oneClass.itemValue === event.target.value);
                        for (const subclassData of foundClass.otherItems) {
                            subclassArray.push({
                                itemValue: subclassData.subclassId,
                                itemText: subclassData.subclassName
                            })
                        }
                        setSubclasses(subclassArray)
                        setNewNPC({
                            ...newNPC,
                            Class: {
                                ...newNPC.Class,
                                classId: toInteger(event.target.value),
                                className: event.target.name
                            }
                        })
                    }} items={classes} label="Klasse"/>
                </div>
                {newNPC.Class.classId > 0 && subclasses.length !== 0 && (
                    <div className='col-6'>
                        <DropDown value={newNPC.Subclass.subclassId} setValue={(event) => setNewNPC({
                            ...newNPC,
                            Subclass: {
                                ...newNPC.Subclass,
                                subclassId: toInteger(event.target.value),
                                subclassName: event.target.name
                            }
                        })} items={subclasses} label="Subklasse"/>
                    </div>
                )}
            </div>
        </PopUp>
    )
}